import React from 'react';
import { IProposta } from '../../../utility/IProposta';
import { agruparPropostasPorData } from '../../../utility/groupProposalsByDate';
import DiaListaDemandas from '../DiaListaDemandas';
import ListaDemandasVazia from '../ListaDemandasVazia';
import SkeletonListaDemandas from '../SkeletonListaDemandas';
import PaginacaoListaDemandas from '../PaginacaoListaDemandas';
import { Container } from './styles';

interface Pagination {
  pagina_atual: number;
  total_paginas: number;
  total_registros: number;
  registros_por_pagina: number;
}

interface BlocoListaDemandasProps {
  propostas: IProposta[];
  loading?: boolean;
  paginacao?: Pagination;
  carregaPagina?: (pagina: number) => void;
}

export default function BlocoListaDemandas({ 
  propostas, 
  loading = false, 
  paginacao, 
  carregaPagina 
}: BlocoListaDemandasProps) {
  
  if (loading) {
    return <SkeletonListaDemandas />;
  }

  if (propostas.length === 0) {
    return <ListaDemandasVazia />;
  }

  const propostasAgrupadas = agruparPropostasPorData(propostas);

  return (
    <Container>
      {Object.entries(propostasAgrupadas).map(([data, propostasDoDia]) => (
        <DiaListaDemandas
          key={data}
          data={data}
          propostas={propostasDoDia as IProposta[]}
        />
      ))}
      
      {paginacao && carregaPagina && (
        <PaginacaoListaDemandas
          paginacao={paginacao}
          carregaPagina={carregaPagina}
        />
      )}
    </Container>
  );
}
